import React from 'react';
import sanitizeHtml from 'sanitize-html';
import '../page/inquiry.css';
import InquiryImageModal from "./InquiryImageModal";
import * as apiUtil from "../../../util/apiUtil";

class InquiryDetailTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            modalFile: null,
            selectOrder: null,
            isUserFile: null,
        };

        this.downloadFile = this.downloadFile.bind(this);
        this.handleFileClick = this.handleFileClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    handleFileClick(file, order, isUserFile) {
        const filenameLower = file.filename.toLowerCase();
        const isImage = /\.(jpe?g|png|gif|bmp)$/i.test(filenameLower);
        const isPdf = filenameLower.endsWith('.pdf');


        if (isImage) {
            this.setState({
                isModalOpen: true,
                modalFile: file,
                selectOrder: order,
                isUserFile: isUserFile,
            });
        } else if (isPdf) {
            window.open(file.fileUrl, '_blank');
        } else {
            this.downloadFile(file.filename, order, isUserFile);
        }
    }

    downloadFile(filename, order, isUserFile) {
        const { uid } = this.props;

        apiUtil.fileDownloadRequest({
            setLoading: this.setLoading,
            url: `/api/inquiry/file/download`,
            method: apiUtil.requestMethod.POST,
            data: {
                uid: uid,
                userFile: isUserFile ? 'user' : 'admin',
                order: order,
            },
            success: (blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
    }

    closeModal() {
        this.setState({
            isModalOpen: false,
            modalFile: null,
        });
    }

    renderFileItem(files, isUserFile) {
        if (!files || files.length === 0) {
            return <div className="text-muted">첨부된 파일이 없습니다.</div>;
        }

        return (
            <div className="file-list-detail file-list-block">
                {files.map((file, index) => (
                    <div key={index} className="file-item-row">
                        <span
                            className="file-item-text file-item-link"
                            onClick={() => this.handleFileClick(file, index, isUserFile)}
                        >
                            {file.filename}
                        </span>
                    </div>
                ))}
            </div>
        );
    }

    formatContent(content) {
        if (!content) return { __html: '' };
        const sanitized = sanitizeHtml(content, { allowedTags: [], allowedAttributes: {} });
        const formattedText = sanitized.replace(/\r\n/g, '\n').replace(/\n/g, '<br />');
        return { __html: formattedText };
    }

    render() {
        const { inquiry, handleDelete } = this.props;
        const { isModalOpen, modalFile, selectOrder, isUserFile } = this.state;

        if (!inquiry || Object.keys(inquiry).length === 0) {
            return <div className="text-center p-5">문의 정보를 불러오는 중입니다.</div>;
        }

        // 답변 존재 여부 확인
        // inquiry.answerContent 필드를 사용한다고 가정하고 수정합니다.
        const hasAnswer = inquiry.status === 'ANSWER' && inquiry.answer;

        // 첨부 파일 목록 (inquiryFiles: 문의 첨부, answerFiles: 답변 첨부)
        const inquiryFiles = inquiry.files || [];
        const answerFiles = inquiry.answerFiles || [];


        return (
            <div className="inquiry-detail-table">
                {/* 1. 문의 정보 테이블 */}
                <table className="table detail-table mb-4">
                    <tbody>
                    <tr className="text-center">
                        <th className="detail-header-col required info-header inquiry-content-header">문의유형</th>
                        <td className="detail-content-col info-content">
                            {inquiry.categoryName}
                        </td>
                        <th className="detail-header-col info-header">상태</th>
                        <td className="detail-content-col info-content">
                        <span className={`status-badge status-${inquiry.status || 'WAIT'}`}>
                            {inquiry.status === 'ANSWER' ? '답변 완료' : '등록'}
                        </span>
                        </td>
                        <th className="detail-header-col info-header">등록일</th>
                        <td className="detail-content-col info-content">
                            {inquiry.createdAt.split(' ')[0]}
                        </td>
                        <th className="detail-header-col info-header">답변날짜</th>
                        <td className="detail-content-col info-content">
                            {inquiry.answerUpdatedAt ? inquiry.answerUpdatedAt.split(' ')[0] : inquiry.answerCreatedAt ? inquiry.answerCreatedAt.split(' ')[0] : '-'}
                        </td>
                    </tr>
                    <tr>
                        <th className="detail-header-col required text-center">문의제목</th>
                        <td colSpan="7" className="detail-content-col">
                            {inquiry.title}
                        </td>
                    </tr>
                    <tr>
                        <th className="detail-header-col attachment-header text-center">첨부파일</th>
                        <td colSpan="7" className="detail-content-col attachment-row">
                            {this.renderFileItem(inquiryFiles, true)}
                        </td>
                    </tr>
                    <tr>
                        <th className="detail-header-col required inquiry-content-header text-center">문의내용</th>
                        <td colSpan="7" className="detail-content-col inquiry-content-row">
                            <div className="pre-wrap inquiry-content-display"
                                 dangerouslySetInnerHTML={this.formatContent(inquiry.content)}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                {!hasAnswer && (
                    <div className="d-flex justify-content-end me-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleDelete}
                        >
                            삭제하기
                        </button>
                    </div>
                    )
                }

                    {/* 2. 답변 내용 영역 (답변이 있을 때만 표시) */}
                {hasAnswer && (
                    <div className="answer-section mt-5">
                        <h4 className="answer-title mb-3">
                            <span className="me-2">❓</span> 답변 내용
                        </h4>

                        <table className="table detail-table answer-table">
                            <tbody>
                            <tr>
                                <th className="detail-header-col required inquiry-content-header text-center">답변내용</th>
                                <td colSpan="7" className="detail-content-col answer-content-row">
                                    <div
                                        className="pre-wrap inquiry-content-display"
                                        dangerouslySetInnerHTML={this.formatContent(inquiry.answer)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th className="detail-header-col attachment-header text-center">첨부파일</th>
                                <td colSpan="7" className="detail-content-col attachment-row">
                                    {this.renderFileItem(answerFiles, false)}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        {/* 1:1 문의 바로가기 버튼 및 안내 문구 */}
                        <div className="d-flex justify-content-between align-items-center mt-3 p-3 border-top">
                            <p className="text-muted small mb-0">
                                * 추가 문의 사항이 있으신 경우, 1:1 문의를 등록해주세요.
                            </p>
                            <a href="/announce/inquiry/create" className="btn btn-sm btn-outline-primary">
                                1:1 문의 바로가기
                            </a>
                        </div>
                    </div>
                )}

                {isModalOpen && modalFile && (
                    <InquiryImageModal
                        show={isModalOpen} // InquiryImageModal이 사용하는 prop 이름 (show)
                        file={modalFile}
                        isUserFile={isUserFile}
                        showDownload={true} // 다운로드 버튼 표시
                        order={selectOrder}
                        downloadFile={this.downloadFile}
                        onClose={this.closeModal}
                    />
                )}
            </div>
        );
    }
}

export default InquiryDetailTable;